import React from "react";
import styled from "styled-components";
import { useProfile } from '../context/ProfileContext';
import { useLocation, useNavigate } from "react-router-dom";
import img8 from '../assets/frontimges/logo.png'
const NavbarContainer = styled.nav`
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  padding: 14px 0px;
  position: fixed;
  overflow-y: auto;
  z-index: 1000;
  width: 100%;
`;

const Logo = styled.div`
  font-size: 2.2rem;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
  z-index: 2;

  @media (max-width: 600px) {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.4rem;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 21px;
`;

const LogoText = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
background: white;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

const WalletIcon = styled.div`
  font-size: 1.5rem;
  margin-right: 21px;
  cursor: pointer;
  transition: transform 0.3s, color 0.3s;

  &:hover {
    transform: scale(1.1);
    color: #f39c12;
  }
`;

const BalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 21px;
`;

const BalanceText = styled.div`
  font-size: 1rem;
  font-weight: 500;
  background: white;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  padding-right: 10px;
`;

const ExposureText = styled.div`
  font-size: 0.8rem;
  color: ${props => props.amount > 0 ? '#fff' : '#fff'};
  margin-top: 2px;
  font-weight: ${props => props.amount > 0 ? '500' : '400'};
`;

export default function Navbar() {
  const { profile } = useProfile();
  const location = useLocation();
  const navigate = useNavigate();
  //  console.log(profile.sessionexposure,"eprofile.sessionexposureprofile.sessionexposureprofile.sessionexposureprofile.sessionexposure")
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/"); 
  };

  return (
    <NavbarContainer>
      <LogoContainer>
      <Logo onClick={() => navigate('/')}>
          <img
            src={img8}
            alt="YOX9 Logo"
            style={{ height: "63px", cursor: "pointer" }}
          />
        </Logo>
      </LogoContainer>
      
     <BalanceContainer>
        <BalanceText>
        Balance: ₹{((profile.walletBalance || 0))}
        </BalanceText>
        <ExposureText amount={profile.exposureBalance}>
        Exposure: ₹{((profile.exposureBalance || 0) + (profile.sessionexposure || 0))}
        </ExposureText>
      </BalanceContainer>

      {/* <WalletIcon onClick={handleLogout}>
        
      </WalletIcon> */}
    </NavbarContainer>
  );
}
